import PropTypes from 'prop-types';
import React from 'react';

export default function DeskPhone(props) {
  const { fill } = props;
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_21279_235503)">
        <path
          d="M5.57132 3.86659H5.56216C4.72892 4.05171 3.98378 4.51555 3.44983 5.18145C2.91588 5.84736 2.62509 6.6755 2.62549 7.52904V8.2707C2.62549 8.60221 2.75719 8.92015 2.99161 9.15457C3.22602 9.38898 3.54397 9.52068 3.87549 9.52068H7.00049C7.33201 9.52068 7.64996 9.38898 7.88437 9.15457C8.1188 8.92015 8.25049 8.60221 8.25049 8.2707C8.25049 7.93918 8.38219 7.62124 8.61661 7.38682C8.85102 7.15241 9.16897 7.02071 9.50049 7.02071H14.5005C14.832 7.02071 15.15 7.15241 15.3844 7.38682C15.6188 7.62124 15.7505 7.93918 15.7505 8.2707C15.7505 8.60221 15.8822 8.92015 16.1166 9.15457C16.351 9.38898 16.669 9.52068 17.0005 9.52068H20.1255C20.457 9.52068 20.775 9.38898 21.0094 9.15457C21.2438 8.92015 21.3755 8.60221 21.3755 8.2707V7.52904C21.3755 6.67578 21.0846 5.84804 20.5507 5.18247C20.0167 4.5169 19.2717 4.05332 18.4388 3.86825H18.4297C14.1831 3.04562 9.81812 3.04505 5.57132 3.86659Z"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M5.12451 12.0226V17.0225C5.12451 18.0171 5.5196 18.9709 6.22286 19.6741C6.92612 20.3774 7.87995 20.7725 8.87451 20.7725H15.1245C16.1191 20.7725 17.0729 20.3774 17.7762 19.6741C18.4794 18.9709 18.8745 18.0171 18.8745 17.0225V12.0226"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M8.56152 13.8961C8.38893 13.8961 8.24902 13.7562 8.24902 13.5836C8.24902 13.411 8.38893 13.2711 8.56152 13.2711"
          stroke={fill}
          strokeWidth="1.25"
        />
        <path
          d="M8.56201 13.8961C8.7346 13.8961 8.87451 13.7562 8.87451 13.5836C8.87451 13.411 8.7346 13.2711 8.56201 13.2711"
          stroke={fill}
          strokeWidth="1.25"
        />
        <path
          d="M8.56152 17.0206C8.38893 17.0206 8.24902 16.8807 8.24902 16.7081C8.24902 16.5355 8.38893 16.3956 8.56152 16.3956"
          stroke={fill}
          strokeWidth="1.25"
        />
        <path
          d="M8.56201 17.0205C8.7346 17.0205 8.87451 16.8806 8.87451 16.708C8.87451 16.5354 8.7346 16.3955 8.56201 16.3955"
          stroke={fill}
          strokeWidth="1.25"
        />
        <path
          d="M11.999 13.8961C11.8264 13.8961 11.6865 13.7562 11.6865 13.5836C11.6865 13.411 11.8264 13.2711 11.999 13.2711"
          stroke={fill}
          strokeWidth="1.25"
        />
        <path
          d="M11.999 13.8961C12.1716 13.8961 12.3115 13.7562 12.3115 13.5836C12.3115 13.411 12.1716 13.2711 11.999 13.2711"
          stroke={fill}
          strokeWidth="1.25"
        />
        <path
          d="M12.001 17.0201C11.8284 17.0201 11.6885 16.8802 11.6885 16.7076C11.6885 16.5351 11.8284 16.3951 12.001 16.3951"
          stroke={fill}
          strokeWidth="1.25"
        />
        <path
          d="M12.001 17.0205C12.1736 17.0205 12.3135 16.8806 12.3135 16.708C12.3135 16.5354 12.1736 16.3955 12.001 16.3955"
          stroke={fill}
          strokeWidth="1.25"
        />
        <path
          d="M15.4385 13.8961C15.2659 13.8961 15.126 13.7562 15.126 13.5836C15.126 13.411 15.2659 13.2711 15.4385 13.2711"
          stroke={fill}
          strokeWidth="1.25"
        />
        <path
          d="M15.4385 13.8961C15.6111 13.8961 15.751 13.7562 15.751 13.5836C15.751 13.411 15.6111 13.2711 15.4385 13.2711"
          stroke={fill}
          strokeWidth="1.25"
        />
        <path
          d="M15.4385 17.0201C15.2659 17.0201 15.126 16.8802 15.126 16.7076C15.126 16.5351 15.2659 16.3951 15.4385 16.3951"
          stroke={fill}
          strokeWidth="1.25"
        />
        <path
          d="M15.4385 17.0205C15.6111 17.0205 15.751 16.8806 15.751 16.708C15.751 16.5354 15.6111 16.3955 15.4385 16.3955"
          stroke={fill}
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_21279_235503">
          <rect fill="white" height="19.9997" transform="translate(2 2.00012)" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
}

DeskPhone.propTypes = {
  fill: PropTypes.string.isRequired
};
